import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
import useProductBasicQueryOptions from 'data-hooks/useProductBasicDetails/useProductBasicQueryOptions';
import { PRODUCT_BASIC_DETAILS } from 'data-hooks/queries';
import useUserData from 'data-hooks/useUserData';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';
const usePDPCreateContextValue = (t0, t1) => {
  const $ = _c(37);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    isEditOrder: t3,
    isQuickView: t4,
    pdpIsModularBYOProduct: t5,
    pdpVariantSkuOverride: t6,
    productOptions: initialProductOptions,
    productBasicDetails: initialProductBasicDetails
  } = t2;
  const isEditOrder = t3 === undefined ? false : t3;
  const isQuickView = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = t5 === undefined ? false : t5;
  const pdpVariantSkuOverride = t6 === undefined ? null : t6;
  let t7;
  if ($[2] !== t1) {
    t7 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const {
    skip: t8
  } = t7;
  const skip = t8 === undefined ? false : t8;
  usePDPRedirectDoubleQuery();
  const seededBasicDetails = initialProductBasicDetails?.basicDetails ?? null;
  const hasSeededBasicDetails = !!seededBasicDetails;
  const t9 = skip || hasSeededBasicDetails;
  let t10;
  if ($[4] !== t9) {
    t10 = {
      skip: t9
    };
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const suspenseBasicDetails = useProductBasicDetails(null, slug, undefined, t10);
  const {
    isLoggedIn
  } = useUserData();
  let t11;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {};
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  const t12 = skip || !hasSeededBasicDetails || !isLoggedIn;
  let t13;
  if ($[7] !== t12) {
    t13 = {
      skip: t12
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  let t14;
  if ($[9] !== slug || $[10] !== t13) {
    t14 = {
      id: null,
      slug,
      queryOptions: t11,
      hookOptions: t13
    };
    $[9] = slug;
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const loggedInQueryOptions = useProductBasicQueryOptions(t14);
  const {
    data: loggedInBasicDetailsData
  } = useQuery(PRODUCT_BASIC_DETAILS, loggedInQueryOptions);
  let t15;
  if ($[12] !== hasSeededBasicDetails || $[13] !== loggedInBasicDetailsData?.basicDetails || $[14] !== seededBasicDetails || $[15] !== suspenseBasicDetails) {
    t15 = hasSeededBasicDetails ? {
      loading: false,
      error: null,
      data: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails,
      rawLoading: false,
      rawData: {
        basicDetails: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails
      },
      refetch: suspenseBasicDetails.refetch
    } : suspenseBasicDetails;
    $[12] = hasSeededBasicDetails;
    $[13] = loggedInBasicDetailsData?.basicDetails;
    $[14] = seededBasicDetails;
    $[15] = suspenseBasicDetails;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const basicDetails = t15;
  const productId = basicDetails?.data?.id || null;
  const t16 = !isQuickView && !isEditOrder;
  let t17;
  if ($[17] !== initialProductOptions || $[18] !== pdpVariantSkuOverride || $[19] !== productId || $[20] !== slug || $[21] !== t16) {
    t17 = {
      id: productId,
      slug,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: t16,
      initialProductOptions
    };
    $[17] = initialProductOptions;
    $[18] = pdpVariantSkuOverride;
    $[19] = productId;
    $[20] = slug;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== skip) {
    t18 = {
      skip
    };
    $[23] = skip;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const {
    atoms,
    productOptions
  } = usePDPCreateProductOptions(t17, t18);
  let t19;
  if ($[25] !== basicDetails || $[26] !== productOptions) {
    t19 = {
      basicDetails,
      productOptions
    };
    $[25] = basicDetails;
    $[26] = productOptions;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  const stockAvailability = usePDPGetStockAvailability(t19);
  let t20;
  if ($[28] !== atoms || $[29] !== basicDetails || $[30] !== pdpIsModularBYOProduct || $[31] !== pdpVariantSkuOverride || $[32] !== productId || $[33] !== productOptions || $[34] !== slug || $[35] !== stockAvailability) {
    t20 = {
      atoms,
      basicDetails,
      id: productId,
      pdpIsModularBYOProduct,
      pdpVariantSkuOverride,
      pdpIsAvailableInSizesOpen: true,
      productOptions,
      stockAvailability,
      slug
    };
    $[28] = atoms;
    $[29] = basicDetails;
    $[30] = pdpIsModularBYOProduct;
    $[31] = pdpVariantSkuOverride;
    $[32] = productId;
    $[33] = productOptions;
    $[34] = slug;
    $[35] = stockAvailability;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
};
export default usePDPCreateContextValue;